import imgLogo from "../assets/images/img_app_logo.png";
import imgWhiteLogo from "../assets/images/aditi/img_white_logo.svg";
import imgDownloadApp from "../assets/images/img_download_app.png";
import imgTwitter from "../assets/images/img_twitter.png";
import imgSheroes from "../assets/images/img_sheroes.png";
import imgLinkedin from "../assets/images/img_linkedin.png";
import imgInstagram from "../assets/images/img_instagram.png";
import imgFacebook from "../assets/images/img_facebook.png";
import imgRupeeCircleLogo from "../assets/images/img_rupee_circle_logo.png";
import imgIndiumLogo from "../assets/images/indium_logo.png";
import imgPartnerCapitalTrade from "../assets/images/img_partner_capital_trade.png";
import imgLadyBanner from "../assets/images/img_lady_banner.gif";
import imgHomeIntroBg from "../assets/images/img_home_intro_bg.png";
import imgGirlWithPhoneBanner from "../assets/images/img_girl_phone_banner.gif";
import imgFinancialProductServicesBanner from "../assets/images/img_financial_product_services_banner.png";
import imgAppLoan from "../assets/images/img_app_loan.png";
import imgRocket from "../assets/images/img_rocket.gif";
import imgGoalsSavings from "../assets/images/img_goals_savings.png";
import memberImg1 from "../assets/images/member-1.png";
import memberImg2 from "../assets/images/member-2.png";
import startGroup from "../assets/images/star-group.png";
import imgCommunityLadies from "../assets/images/img_community_lady.png";
import imgRewards from "../assets/images/img_rewards.gif";
import imgAppMobile from "../assets/images/img_app_mobile.png";
import imgProductsBg from "../assets/images/img_product_bg.png";
import imgMoneyBag from "../assets/images/img_loan_bag.png";
import imgCongratulationsPhone from "../assets/images/img_congratulations_phone.gif";
import imgFeatureIconCircle from "../assets/images/img_feature_icon_circle.png";
import imgTechnicalSupport from "../assets/images/img_technical_support.png";
import imgVerify from "../assets/images/img_verify.png";
import imgEventLive from "../assets/images/img_event_live.png";
import imgLoanAbout from "../assets/images/img_loan_about.png";
import imgLoanPhone from "../assets/images/img_loan_phone.png";
import imgPaperlessProcess from "../assets/images/img_paperless_process_icon.png";
import imgNoCollateral from "../assets/images/img_no_collateral.png";
import imgProtectAbout from "../assets/images/img_protect_about.jpeg";
import imgMoney from "../assets/images/img_money_icon.png";
import imgOutlineDoc from "../assets/images/img_outline_doc_icon.png";
import imgInsurance from "../assets/images/img_insurance.png";
import imgDeduction from "../assets/images/img_deduction_icon.png";
import imgNoDeductibleApplicable from "../assets/images/img_no_deductible_applicable.jpeg";
import imgInsuranceCover from "../assets/images/img_insurance_cover.jpeg";
import imgNotFound from "../assets/images/img_not_found.png";
import imgProtectPlus from "../assets/images/img_protect_plus.png";
import imgAditiVector1 from "../assets/images/aditi/img_aditi_vector1.svg";
import imgAditiVector2 from "../assets/images/aditi/img_aditi_vector2.svg";
import imgAditiVector3 from "../assets/images/aditi/img_aditi_vector3.svg";
import imgAditiVector4 from "../assets/images/aditi/img_aditi_vector4.svg";
import imgAditiVector5 from "../assets/images/aditi/img_aditi_vector5.svg";
import imgAditiPerson1 from "../assets/images/aditi/person1.png";
import imgAditiPerson2 from "../assets/images/aditi/person2.png";
import imgAditiPerson3 from "../assets/images/aditi/person3.png";
import imgAditiPerson4 from "../assets/images/aditi/person4.png";
import imgAditiPerson5 from "../assets/images/aditi/person5.png";
import imgAditiPerson6 from "../assets/images/aditi/person6.png";
import imgMahilaMoney from "../assets/images/aditi/img_mahila_money.svg";
import imgAditiThumbnail1 from "../assets/images/aditi/img_aditi_video_1.jpg";
import imgAditiThumbnail2 from "../assets/images/aditi/img_aditi_video_2.jpg";
import imgAditiThumbnail3 from "../assets/images/aditi/img_aditi_video_3.jpg";
import icPlay from "../assets/images/aditi/ic_play.svg";
import icAditiFund1 from "../assets/images/aditi/ic_fund.svg";
import icAditiFund2 from "../assets/images/aditi/ic_graph.svg";
import icAditiFund3 from "../assets/images/aditi/ic_growth.svg";
import imgAditiStepsBg from "../assets/images/aditi/img_steps_bg.svg";
import icAditiStep1 from "../assets/images/aditi/ic_step1.svg";
import icAditiStep2 from "../assets/images/aditi/ic_step2.svg";
import icAditiStep3 from "../assets/images/aditi/ic_step3.svg";
import icAditiStep4 from "../assets/images/aditi/ic_step4.svg";
import icArrowUp from "../assets/images/aditi/ic_arrow_up.svg";
import icArrowDown from "../assets/images/aditi/ic_arrow_down.svg";
import icBlackCross from "../assets/images/aditi/ic_cross.png";
import imgAditiStep from "../assets/images/aditi/img_steps.svg";
import imgHalfYellowVector from "../assets/images/businessLoan/img_half_yellow_vector.png";
import imgHalfPeachVector from "../assets/images/businessLoan/img_half_peach_vector.svg";
import imgLoanHero from "../assets/images/businessLoan/img_hero_image.png";
import imgStars from "../assets/images/businessLoan/ic_stars.png";
import imgBlueStar from "../assets/images/businessLoan/ic_blue_star.png";
import imgOrangeStar from "../assets/images/businessLoan/ic_orange_star.png";
import icPaperLess from "../assets/images/businessLoan/ic_paperless.png";
import icNoCollateral from "../assets/images/businessLoan/ic_no_collateral.png";
import icVersatileLoan from "../assets/images/businessLoan/ic_versatile_loan.png";
import icFullyTransparent from "../assets/images/businessLoan/ic_fully_transparent.png";
import imgWhyLoan from "../assets/images/businessLoan/img_why_loan.png";
import imgSkyLoan from "../assets/images/businessLoan/img_sky_loan.svg";
import imgGrowMyLoan from "../assets/images/businessLoan/img_grow_business_loan.svg";
import imgStarterLoan from "../assets/images/businessLoan/img_starter_loan.svg";
import imgEligibilityBadge from "../assets/images/businessLoan/img_eligibility_badge.svg";
import icGreenTick from "../assets/images/businessLoan/ic_green_tick.png";
import icGreyCircle from "../assets/images/businessLoan/ic_grey_circle.png";
import icGreenCircle from "../assets/images/businessLoan/ic_green_circle.png";
import icDonut from "../assets/images/businessLoan/ic_donut.png";
import imgEmiCalBanner from "../assets/images/businessLoan/img_emi_cal_banner.svg";
import imgStepsForApply1 from "../assets/images/businessLoan/img_steps_for_apply_1.png";
import imgStepsForApply2 from "../assets/images/businessLoan/img_steps_for_apply_2.png";
import imgStepsForApply3 from "../assets/images/businessLoan/img_steps_for_apply_3.png";
import imgYellowStar from "../assets/images/businessLoan/img_yellow_star.png";
import icCall from "../assets/images/businessLoan/ic_call.svg";
import icMail from "../assets/images/businessLoan/ic_mail.svg";
import imgCustomerSupport from "../assets/images/businessLoan/img_support.svg";
import imgGrowStep1 from "../assets/images/businessLoan/img_grow_step1.png";
import imgGrowStep2 from "../assets/images/businessLoan/img_grow_step2.png";
import imgGrowStep3 from "../assets/images/businessLoan/img_grow_step3.png";
import imgImpactLeftCircles from "../assets/images/businessLoan/img_impact_left_circles.png";
import imgImpactRightCircles from "../assets/images/businessLoan/img_impact_right_circles.png";
import imgAditiBanner from "../assets/images/businessLoan/img_aditi.png";
import imgDharaBanner from "../assets/images/businessLoan/img_dhara.png";
import imgAditiCard from "../assets/images/businessLoan/img_aditi_card.png";
import imgDMILogo from "../assets/images/img_DMI_logo.png";



const AppIcons = {
  imgLogo,
  imgWhiteLogo,
  imgMahilaMoney,
  imgAditiVector1,
  imgAditiVector2,
  imgAditiVector3,
  imgAditiVector4,
  imgAditiVector5,
  imgAditiPerson1,
  imgAditiPerson2,
  imgAditiPerson3,
  imgAditiPerson4,
  imgAditiPerson5,
  imgAditiPerson6,
  imgAditiStepsBg,
  imgAditiStep,
  icPlay,
  icBlackCross,
  icArrowUp,
  icArrowDown,
  icAditiFund1,
  icAditiFund2,
  icAditiFund3,
  icAditiStep1,
  icAditiStep2,
  icAditiStep3,
  icAditiStep4,
  imgAditiThumbnail1,
  imgAditiThumbnail2,
  imgAditiThumbnail3,
  imgDownloadApp,
  imgTwitter,
  imgSheroes,
  imgLinkedin,
  imgInstagram,
  imgFacebook,
  imgRupeeCircleLogo,
  imgIndiumLogo,
  imgPartnerCapitalTrade,
  imgLadyBanner,
  imgHomeIntroBg,
  imgGirlWithPhoneBanner,
  imgFinancialProductServicesBanner,
  imgAppLoan,
  imgRocket,
  imgGoalsSavings,
  memberImg1,
  startGroup,
  memberImg2,
  imgCommunityLadies,
  imgRewards,
  imgAppMobile,
  imgProductsBg,
  imgMoneyBag,
  imgCongratulationsPhone,
  imgFeatureIconCircle,
  imgTechnicalSupport,
  imgVerify,
  imgEventLive,
  imgLoanAbout,
  imgLoanPhone,
  imgPaperlessProcess,
  imgNoCollateral,
  imgProtectAbout,
  imgMoney,
  imgOutlineDoc,
  imgInsurance,
  imgDeduction,
  imgNoDeductibleApplicable,
  imgInsuranceCover,
  imgNotFound,
  imgProtectPlus,
  imgLoanHero,
  imgHalfYellowVector,
  imgHalfPeachVector,
  imgStars,
  imgBlueStar,
  imgOrangeStar,
  icPaperLess,
  icNoCollateral,
  icVersatileLoan,
  icFullyTransparent,
  icGreenTick,
  icGreyCircle,
  icGreenCircle,
  icDonut,
  imgWhyLoan,
  imgSkyLoan,
  imgGrowMyLoan,
  imgStarterLoan,
  imgEligibilityBadge,
  imgEmiCalBanner,
  imgStepsForApply1,
  imgStepsForApply2,
  imgStepsForApply3,
  imgYellowStar,
  icCall,
  icMail,
  imgCustomerSupport,
  imgGrowStep1,
  imgGrowStep2,
  imgGrowStep3,
  imgImpactLeftCircles,
  imgImpactRightCircles,
  imgAditiBanner,
  imgDharaBanner,
  imgAditiCard,
  imgDMILogo
};

export default AppIcons;
